var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExamNonSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Exam_-_Non_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - Exam - Non Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-3{fill:none;stroke:#afafaf;stroke-linecap:round;stroke-width:1.2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Exam_-_Non_Selected-2",
    "data-name": "Icon - Exam - Non Selected",
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H16V16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3633",
    "data-name": "Group 3633",
    transform: "translate(.8 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6236",
    fill: "none",
    stroke: "#afafaf",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M13.079 5.669V2.6a1.6 1.6 0 0 0-1.6-1.6H2.533a1.6 1.6 0 0 0-1.6 1.6v11.2a1.6 1.6 0 0 0 1.6 1.6H5.4",
    "data-name": "Path 6236",
    transform: "translate(-.933 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6238",
    d: "M-.5 0h6.544",
    className: "prefix__cls-3",
    "data-name": "Path 6238",
    transform: "translate(3.3 3.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6239",
    d: "M-.5 0h6.544",
    className: "prefix__cls-3",
    "data-name": "Path 6239",
    transform: "translate(3.3 6.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6240",
    d: "M-.5 0h4.547",
    className: "prefix__cls-3",
    "data-name": "Path 6240",
    transform: "translate(3.3 8.582)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3632",
    fill: "none",
    stroke: "#afafaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 3632",
    transform: "translate(7.666 7.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6237",
    strokeWidth: "2px",
    d: "M16.8 13.14l-3.636 3.636-2.644.529.529-2.644 3.636-3.636a1.506 1.506 0 0 1 2.181-.066 1.491 1.491 0 0 1-.066 2.181z",
    "data-name": "Path 6237",
    transform: "translate(-10.515 -10.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_134",
    strokeWidth: "1.2px",
    d: "M0 0L2.115 2.115",
    "data-name": "Line 134",
    transform: "translate(3.799 .867)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExamNonSelected);
export default __webpack_public_path__ + "static/media/icon-exam-non-selected.2cbf8b345cc5ccde49acf5c23b3a7179.svg";
export { ForwardRef as ReactComponent };